import React, { useEffect, useRef, useState } from "react";
import { Input, Form, Button, Select } from "Components";
import { useIntl } from "react-intl";
import useOptions from "Modules/dashboard/views/landmarkRealTime/constants/options";
import { useSelector } from "react-redux";
import TagsManage from "Modules/.common/components/TagsManage";
//styles
import "./landmarkRealTime.scss";

const CreateEditOfflineLandmarkRealTime = (props) => {
  const { onSubmit, handleClose } = props;
  const { messages, locale } = useIntl();
  const { entities, parameterOrder } = useOptions(messages);
  const refForm = useRef(null);
  const [isLandmarksValid, setIsLandmarksValid] = useState(true);
  const { loadingCreateEdit, gadGet } = useSelector(
    (state) => state.dashboardPanelRedux
  );
  const [formData, setFormData] = useState({
    name: "",
    refreshSeconds: 60,
    parameterOrder: "",
    landmarksToSearch: [],
  });
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    setIsLandmarksValid(formData.landmarksToSearch.length > 0);
  }, [formData.landmarksToSearch]);

  useEffect(() => {
    if (gadGet.hasOwnProperty("name")) {
      let settings = JSON.parse(gadGet.settings);
      setFormData({
        name: gadGet.name,
        refreshSeconds: 60,
        parameterOrder: parameterOrder.find(
          (x) => x.id == settings?.parameterOrder
        ),
        landmarksToSearch: settings?.landmarksToSearch,
      });
    }
    setLocalLoading(false);
    return () => {
      setFormData({
        name: "",
        refreshSeconds: 60,
        parameterOrder: "",
        landmarksToSearch: [],
      });
    };
  }, [open, gadGet]);

  const validateData = () => {
    if (!isLandmarksValid) return;

    const dataToValidate = {
      name: formData?.name,
      refreshSeconds: 60,
      parameterOrder: formData?.parameterOrder.id,
      landmarksToSearch: formData?.landmarksToSearch,
    };

    onSubmit(dataToValidate);
  };

  const onChangeEntity = (newSelectedEntity) => {
    if (newSelectedEntity.id == "All") {
      setFormData({
        ...formData,
        landmarksToSearch: [{ id: "-1", name: "All" }],
      });
      setIsLandmarksValid(true);
    } else {
      setFormData({ ...formData, landmarksToSearch: [] });
      setIsLandmarksValid(false);
    }
  };

  const onChange = (selectedItems, entity) => {
    setFormData({ ...formData, landmarksToSearch: selectedItems });
    setIsLandmarksValid(selectedItems.length > 0);
  };

  const entity = entities.find(
    (x) =>
      x.id ==
      ((formData.landmarksToSearch?.find(
        (x) => x.id == "-1" && x?.name == "All"
      ) &&
        "All") ||
        "Landmark")
  );

  return (
    <section className="landmark_real_time">
      <Form
        className="landmark_real_time__form"
        ref={refForm}
        onValidSubmit={validateData}
        style={{ height: "100%" }}
      >
        <Input
          id="name"
          value={formData.name}
          onChange={(value) => setFormData({ ...formData, name: value })}
          minLength={1}
          maxLength={25}
          label={messages["dashboardPanel_edit_title"]}
          placeholder={messages["dashboardPanel_edit_title"]}
          type="text"
          required
          requiredMessage={messages["required_field"]}
        />
        <Select
          label={messages["dashboardPanel_order_By"]}
          name="parameterOrder"
          isLoading={false}
          options={parameterOrder}
          textField="name"
          value={formData?.parameterOrder}
          valueField="id"
          placeholder={messages["dashboardPanel_order"]}
          isSearchable={false}
          onChange={(value) =>
            setFormData({ ...formData, parameterOrder: value })
          }
          isClearable
          required
          requiredMessage={messages["required_field"]}
        />
        <section className="landmark_real_time__landmarks">
          <div className={isLandmarksValid ? "labelLandmark" : "text-danger"}>
            <label>
              {!isLandmarksValid ? (
                <span>
                  {messages["alertsNewAlert_landmarkValidation"]}
                  <span style={{ color: "red" }}> *</span>
                </span>
              ) : (
                <span>
                  {messages["alertsNewAlert_landmarkValidation"]}
                  <span style={{ color: "red" }}> *</span>
                </span>
              )}
            </label>
          </div>
          {!localLoading && (
            <div style={{ marginTop: 5 }}>
              <TagsManage
                entities={entities}
                value={formData.landmarksToSearch}
                onChange={onChange}
                hideTagsWithoutEntities={true}
                mode="list"
                height={400}
                entitySelected={entity}
                setEntitySelected={(entity) => {
                  onChangeEntity(entity);
                }}
              />
            </div>
          )}
        </section>
      </Form>
      <section className="landmark_real_time__bottons">
        <Button
          variant="secondary"
          isDisabled={false}
          className="btn-cancel"
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {messages["cancel"]}
        </Button>
        <Button
          variant="primary"
          isDisabled={false}
          onClick={(e) => {
            if (e) e.preventDefault();
            refForm.current.submit();
          }}
          className="btn-blue"
        >
          {messages["save"]}
        </Button>
      </section>
    </section>
  );
};

export default CreateEditOfflineLandmarkRealTime;
